/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Method from './Method/index'
import PaymentProviderLocation from 'DesignSystem/PaymentProvider/PaymentProviderLocation/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/AddMethod/Content",
  amount,
  method,
  locationId,
  person,
  onPaymentPageCallback,
  reusableForBluefin
  
}) {
  return (<React.Fragment
>
<PaymentProviderLocation
  viewPath={`${viewPath}/PaymentProviderLocation`}
 amount={amount}
/>
<Method
  viewPath={`${viewPath}/Method`}
 method={method}
 locationId={locationId}
 person={person}
 amount={amount}
 onPaymentPageCallback={onPaymentPageCallback}
 reusableForBluefin={reusableForBluefin}
/>
{children}
</React.Fragment>)
}